import { Axios } from 'axios'
import { NoticeItem } from '@/repositories/system/noticeRepository'

export interface Authority {
  authority: string;
}

export type ResponseUserStatus = {
  mustUpdatePassword: boolean;
  mustUpdateInitialPassword: boolean;
  mustLinkApi: boolean;
  mustSelectTenant: boolean;
  enableFuzokuMeisaiMenu: boolean;
  enableAdminMenu: boolean;
  enableSystemMenu: boolean;
}

export interface LoginService {
  tryLogin(loginId: string, password: string): Promise<Authority>;
  logout(): Promise<void>;
  getUserStatus(): Promise<ResponseUserStatus>;
  getNotices(): Promise<NoticeItem[]>
}

export class LoginServiceImpl implements LoginService {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios

  async tryLogin (loginId: string, password: string) {
    const { data } = await this.http.post('login', { loginId: loginId, password: password })
    return data
  }

  async logout () {
    await this.http.post('logout')
  }

  async getUserStatus (): Promise<ResponseUserStatus> {
    const { data } = await this.http.get('user-status')
    return data
  }

  async getNotices (): Promise<NoticeItem[]> {
    const { data } = await this.http.get('login/notice')
    return data
  }
}
